import type { BusinessTypeCode } from '../../../shell/session/domain/businessProfile';

/** Rubros con política de stock block por defecto y mismo copy de inventario. */
export const RETAIL_COUNTER_BUSINESS_TYPES: BusinessTypeCode[] = ['retail_counter', 'neighborhood_store'];

export function isRetailCounterBusinessType(code: BusinessTypeCode | string | null | undefined): boolean {
  return code != null && RETAIL_COUNTER_BUSINESS_TYPES.includes(code as BusinessTypeCode);
}
